<template lang="pug">
aside-modal(id="manageEwallet", width="w-xxxl")
    span(slot="header-text")
        span(v-if="isContainData == true") Update
        span(v-else) Create
        | &nbsp;E-Wallet

    div(slot="body")
        div.alert-noty(v-if="isContainData == false")
            | Note: Create e-wallet can be created once only. Unable to undo once it done. Thank you
        .container.p-a
            .loading.p-a(v-if="loading")
                .loading-spinner

            div.md-form-group(:class="{'invalid':errors.has('name')}")
                input.md-input(
                    type="text"
                    name="name"
                    v-model="ewallet.name"
                    :disabled="loading"
                )
                label Name
                span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

            div
                div.md-form-group(:class="{'invalid':errors.has('source')}" )
                    input.md-input(
                        type="text"
                        name="source"
                        v-model="ewallet.source"
                        :disabled="isContainData == true"
                    )
                    label Source
                    span.form-error-msg(v-show="errors.has('source')") {{ errors.first('source') }}

            div(v-if="hasVoidRuleEnabled")
                label Options
                p
                    label.md-switch.has-value
                        input(
                            type="checkbox"
                            name="is_allow_void"
                            v-model="ewallet.is_allow_void"
                            :disabled="loading"
                            )
                        i.indigo
                        | Allow Void

            .row
                .col-md-12
                    label(style="margin-top: 10px;width: 100%;" v-if="metadata.length > 0 && isContainData" ) Custom Field
                        .row
                            .col-md-6
                                label.form-control-label Key
                            .col-md-6
                                label.form-control-label Value

                        .row(v-for="(meta, index) in metadata" :key="index")
                            .col-md-6
                                .form-group(:class="{'has-danger': false}")
                                    input.form-control(
                                        class="input-key"
                                        :id="`key.${index}`"
                                        ref="key"
                                        type="text"
                                        :name="`key[${index}]`"
                                        v-model="meta.key"
                                        v-focus=""
                                        readonly
                                    )

                            .col-md-6
                                .form-group(:class="{'has-danger': false}")
                                    input.form-control(
                                        :id="`value.${index}`"
                                        ref="value"
                                        type="text"
                                        :name="`value[${index}]`"
                                        v-model="meta.value"
                                        v-focus=""
                                        readonly
                                    )

    button.btn.btn-fw.primary(
        slot="footer",
        @click.prevent="submit()",
        :disabled="onLoading('save-ewallet')"
    )
        v-loading(loader="save-ewallet") Save
</template>

<script>
import { mapActions } from 'vuex';
import { default as MetaMixin, EWALLET_MODULE } from '../../../mixins/meta';
import SettingsMixin from '../settings-mixin';
export default {
    mixins: [MetaMixin, SettingsMixin],
    data() {
        return {
            loading: false,
            isContainData: false,
            ewallet: {
                name: '',
                source: '',
                is_allow_void: false,
            },
        };
    },

    watch: {
        ewallet(data, oldValue) {
            if (data != null) {
                this.getMeta(this.ewallet.id, EWALLET_MODULE);
            }
            this.clearValidation();
        },
    },

    created() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('ewallet', ['updateEwallet', 'storeEwallet']),
        showModal() {
            this.toggleModal('show');
        },
        hideModal() {
            this.toggleModal('hide');
        },
        toggleModal(action) {
            $('#manageEwallet').modal(action);
        },
        registerEvent() {
            this.$bus.$on('manage_ewallet::display_form', data => {
                if (data != null) {
                    this.ewallet = data;
                    this.getMeta(data.id, EWALLET_MODULE);
                } else {
                    this.ewallet = this.getEmptyEwallet();
                }

                this.isContainData = data != null;

                this.showModal();
            });
        },
        async submit() {
            this.clearValidation();

            let flag = false;

            for (const [key, value] of Object.entries(this.ewallet)) {
                if (this.validateField(value, key)) {
                    flag = true;
                }
            }

            if (flag) return;

            await this[this.isContainData ? 'updateEwallet' : 'storeEwallet'](
                this.ewallet,
            )
                .then(res => {
                    toastr.success('Successfully update ewallet details');
                    this.$emit('refresh-table');
                    this.hideModal();
                })
                .catch(err => {
                    this.showApiError(err);
                });
        },
        getEmptyEwallet() {
            return {
                name: null,
                source: null,
                is_allow_void: false,
            };
        },
        validateField(value, field) {
            if (
                (field !== 'deleted_at' && _.isNull(value)) ||
                value === '' ||
                value === undefined ||
                String(value).trim() === ''
            ) {
                this.hasValidationError = true;

                this.errors.add({
                    field: field,
                    msg: `The ${_.replace(field, '_', ' ')} field is required`,
                });

                return true;
            }

            return false;
        },
        clearValidation() {
            this.errors.clear();
            this.hasValidationError = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.alert-noty {
    background-color: rgb(255, 166, 50);
    color: rgb(90, 90, 90);
    padding: 15px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/ewallet/form.vue